export function getSongCategoryNames(song) {
  if (!song) return [];
  if (Array.isArray(song.categories) && song.categories.length > 0) {
    return song.categories.filter((c) => typeof c === "string" && c.trim()).map((c) => c.trim());
  }
  if (song.category && typeof song.category === "string" && song.category.trim()) {
    return [song.category.trim()];
  }
  return [];
}

export function isSongExcludedForEvent(song, event) {
  if (!song || !event) return false;

  const discardedSongIds = Array.isArray(event.discardedSongs)
    ? event.discardedSongs.map((id) => Number(id)).filter((id) => Number.isFinite(id))
    : [];
  if (discardedSongIds.includes(Number(song.id))) {
    return true;
  }

  const discardedCategories = Array.isArray(event.discardedCategories)
    ? event.discardedCategories
        .filter((c) => typeof c === "string" && c.trim())
        .map((c) => c.trim())
    : [];
  if (discardedCategories.length === 0) return false;

  const discardedLower = new Set(discardedCategories.map((c) => c.toLowerCase()));
  const songCategories = getSongCategoryNames(song);
  return songCategories.some((cat) => discardedLower.has(cat.toLowerCase()));
}

export function filterSongsForEvent(songs, event) {
  if (!Array.isArray(songs)) return [];
  return songs.filter((song) => !isSongExcludedForEvent(song, event));
}

export function countExcludedSongs(songs, event) {
  if (!Array.isArray(songs) || !event) {
    return { total: 0, byCategory: 0, individualOnly: 0 };
  }

  const excluded = songs.filter((song) => isSongExcludedForEvent(song, event));
  const discardedSongIds = new Set(
    (Array.isArray(event.discardedSongs) ? event.discardedSongs : [])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id))
  );
  const discardedCategories = Array.isArray(event.discardedCategories)
    ? event.discardedCategories.filter((c) => typeof c === "string" && c.trim())
    : [];
  const discardedLower = new Set(discardedCategories.map((c) => c.toLowerCase()));

  const byCategory = songs.filter((song) =>
    getSongCategoryNames(song).some((cat) => discardedLower.has(cat.toLowerCase()))
  ).length;

  const individualOnly = songs.filter((song) => {
    if (!discardedSongIds.has(Number(song.id))) return false;
    if (!discardedLower.size) return true;
    return !getSongCategoryNames(song).some((cat) => discardedLower.has(cat.toLowerCase()));
  }).length;

  return {
    total: excluded.length,
    byCategory,
    individualOnly
  };
}
